<template>
  <b-input
    :value="value"
    :id="id"
    :type="type"
    :size="size"
    expanded
    :icon="iconLeft"
    :icon-right="iconRight"
    :placeholder="placeholder"
    :icon-clickable="iconLeftClickable"
    :icon-clickable-right="iconRightClickable"
    @input="handleInput"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @icon-click="$emit('icon-left-click', $event)"
    @icon-right-click="$emit('icon-right-click', $event)"
  ></b-input>
</template>

<script>
  import {FormFieldMixin} from "./FormField.mixin";

  export default {
    name: "FormInput",
    mixins: [FormFieldMixin],
    props: {
      value: {},
      id: {
        type: Number,
      },
      type: {
        type: String,
        default: 'text'
      },
      size: {
        type: String,
        default: 'is-small'
      },
      placeholder: {
        type: String
      },
      iconLeft: {
        type: String
      },
      iconLeftClickable: {
        type: Boolean,
        default: false,
      },
      iconRight: {
        type: String
      },
      iconRightClickable: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
